import { imgUrl } from "@/lib/api";

export default function Thumb({ path, alt, icon: Icon, className = "w-10 h-10", testid }) {
  return (
    <div className={`${className} rounded-lg border border-border bg-muted overflow-hidden flex items-center justify-center shrink-0`} data-testid={testid}>
      {path ? (
        <img src={imgUrl(path)} alt={alt} className="w-full h-full object-cover" />
      ) : (
        Icon && <Icon className="w-1/2 h-1/2 text-muted-foreground" />
      )}
    </div>
  );
}
